import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, createStore, type Store } from "redux";
import { withExtraArgument as thunk } from "redux-thunk";

import { Action } from "./actions";
import { ReduxState, rootReducer } from "./state";
import { ThunkContext } from "./thunkContext";

export function createReduxStore(
  thunkContext: ThunkContext,
): Store<ReduxState, Action> {
  return createStore(
    rootReducer,
    undefined,
    composeWithDevTools(
      applyMiddleware(thunk<ReduxState, Action, ThunkContext>(thunkContext)),
    ),
  );
}
